module.exports = __webpack_public_path__ + "img/baihe.914053d3.png";